/**
 * A side's Instagram account, as a link out.
 *
 * Sides that have an account want the traffic, and a player looking at a squad
 * list is exactly who they want to reach. Shown only where a handle has been
 * given: an icon that leads nowhere is worse than no icon.
 *
 * Drawn as a bordered chip in the league's accent rather than as a bare glyph.
 * A glyph on its own reads as decoration — and on a phone there is no hover to
 * discover otherwise, so the thing has to look tappable standing still.
 *
 * The mark is drawn here rather than loaded, so it takes the league's own
 * colour and costs no request.
 */

function InstagramGlyph() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="3" y="3" width="18" height="18" rx="5.2" />
      <circle cx="12" cy="12" r="4.1" />
      <circle className="ig-dot" cx="17.4" cy="6.6" r="1.15" />
    </svg>
  );
}

export default function InstagramLink({
  handle,
  name,
  showHandle = false,
}: {
  handle: string;
  name: string;
  /** Puts the @handle beside the mark, for places with room to spare. */
  showHandle?: boolean;
}) {
  return (
    <a
      className={showHandle ? 'ig-link' : 'ig-link icon-only'}
      href={`https://www.instagram.com/${handle}/`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${name} on Instagram (opens Instagram)`}
      title={`@${handle}`}
      // The row underneath opens the squad; tapping the icon should not.
      onClick={(event) => event.stopPropagation()}
    >
      <InstagramGlyph />
      {showHandle && <span>@{handle}</span>}
    </a>
  );
}
